import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Phone, Trash } from 'react-bootstrap-icons';

const IsUserReachableNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define edge labels
  const edgeLabels = ['Yes', 'No'];

  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className="bg-white p-2 shadow-lg border-2 border-yellow-400 rounded-lg relative min-w-[200px] transition-all duration-200 ease-in-out hover:-translate-y-0.5 hover:shadow-xl"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete Button */}
      <div 
        className={`absolute w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer z-10 transition-all duration-200 ease-in-out border border-gray-300 hover:bg-red-500 hover:text-white hover:border-red-500 hover:scale-110 -top-3 left-1/2 transform -translate-x-1/2 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className="w-3 h-3"/>
      </div>

      {/* Node Header */}
      <div className="p-3 pt-5 pb-5 border-b border-yellow-300 rounded-t-lg bg-gradient-to-br from-yellow-50 via-yellow-100 to-yellow-200">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 p-1.5 bg-white rounded-full shadow-md flex items-center justify-center">
            <Phone className="w-6 h-6" style={{ color: '#f6971a' }}/>
          </div>
          <span className="text-yellow-800 font-semibold text-base leading-6">Is user reachable?</span>
        </div>
      </div>

      {/* Input Handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 rounded-full border-2 border-yellow-600 bg-yellow-600 hover:bg-yellow-50 hover:border-yellow-600"
      />

      {/* Output Handles */}
      <div className="absolute right-0 top-1/2 transform -translate-y-1/2 h-12 flex flex-col justify-between">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <div 
            key={`output-${index}`} 
            className="relative"
            style={{
              top: `${(index * 100) / (outputEdges - 1)}%`,
              transform: 'translateY(-50%)'
            }}
          >
            <Handle
              type="source"
              position={Position.Right}
              id={`output-${index}`}
              className="w-3 h-3 rounded-full border-2 border-yellow-600 bg-yellow-600 hover:bg-yellow-50 hover:border-yellow-600"
            />
            <div 
              className={`absolute text-xs font-medium transition-opacity duration-200 ease-in-out bg-white/90 px-1 py-0.5 rounded whitespace-nowrap left-1 -top-1.5 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
            >
              {edgeLabels[index]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IsUserReachableNode; 
